import { createResource, For, Match, Show, Switch } from "solid-js";
import { useApp } from "./context";
import { Currency, image_url, ItemId } from "./api";
import { A, createAsync, useLocation, useNavigate } from "@solidjs/router";
import { format_price, format_size, parse_id_map } from "./util";
import { Header, ShopHeader } from "./header";
import { AttrList, OrderButton } from "./common";


export function Icon({name, action, disabled}: {name: string, action?: () => any, disabled?: boolean}) {
    return (<div class="icon" attr:data-disabled={disabled} on:click={action}>
        <img src={`/style/icons/${name}.svg`} />
    </div>);
}

export function CartAction({id}: {id: ItemId}) {
    const {cart} = useApp();

    const in_cart = () => cart.items.find((item) => item.id === id) !== undefined;

    return (<Switch>
        <Match when={!in_cart()}>
            <Icon name="add-cart" action={() => cart.addToCart(id)} />
        </Match>
        <Match when={in_cart()}>
            <Icon name="del-cart" action={() => cart.remove(id)} />
        </Match>
    </Switch>);
}

export function Cart() {
    const { cart, cache } = useApp();
    const [ready] = createResource(() => cache.preload_items(Array.from(cart.items, ({id}) => id)));

    const itemSum = () => {
        if (!ready()) { return }
        const sums: Map<Currency, number> = new Map();
        for (const entry of cart.items) {
            const item = cache.get_item(entry.id);
            if (item.price !== null) {
                const c = item.price.currency;
                const old = sums.get(c) ?? 0.0;
                sums.set(c, old + item.price.val);
            }
        }
        return Array.from(sums.entries(), ([currency, sum]) => format_price({currency, val: sum})).join(" + ");
    };
    const navigate = useNavigate();

    return (<>
        <div id="fixed">
            <div class="full"><span>{cart.totalQuantity} Items</span></div>
            <div class="full"><OrderButton /></div>
            <div class="full"><span>{itemSum()}</span></div>
        </div>
        <div id="cart">
        <Show when={ready()}>
            <For each={cart.items}>
                {(entry) => {
                    const item = createAsync(() => cache.get_item_async(entry.id));
                    return (<Show when={item()} keyed>
                        {(item) => {
                            const attr_map = parse_id_map(item.attrs);
                            return (<div>
                                <div class="image">
                                    <img src={image_url(item.images[0], 600)} />
                                </div>
                                <div class="desc grid">
                                    <div class="actions">
                                        <Icon name="del-cart" action={() => cart.remove(entry.id)} />
                                    </div>
                                    <dl>
                                        <dt>Item Nr:</dt><dd>{entry.id}</dd>
                                        <dt>Price:</dt><dd>{format_price(item.price)}</dd>
                                        <AttrList attr_map={attr_map} />
                                    </dl>
                                </div>
                            </div>);
                        }}
                    </Show>);
                }}
            </For>
            </Show>
            <div>
                <div class="centered">
                    <OrderButton class="large" />
                </div>
            </div>
        </div>
        </>);
}
